import script from "./HintsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HintsSection.vue?vue&type=script&setup=true&lang=js"

import "./HintsSection.vue?vue&type=style&index=0&id=afd29a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd29a38"]])

export default __exports__